import React from "react";
import { rest } from "../../data/rest/api";
import { startGlobalLoading, stopGlobalLoading } from "../../layout/globalLoading";
import { toast } from "react-toastify";

const POLL_INTERVAL = 5000;

const DbDump = (props) => {
	const [instances, setInstances] = React.useState([]);
	const [selectedInstance, setSelectedInstance] = React.useState("");
	const [output, setOutput] = React.useState("");
	const [dumping, setDumping] = React.useState(false);
	const pollRef = React.useRef(null);

	React.useEffect(() => {
		rest("GET", "/api/instance").then((data) => {
			const list = Array.isArray(data) ? data : data.rows || [];
			setInstances(list);
		}).catch((err) => {
			toast.error("Greška pri dohvatu instanci: " + err.message);
		});

		// Pri mountu provjeri je li neki dump već u tijeku
		rest("GET", "/api/dbDumpActive").then((active) => {
			if (active.running) {
				setSelectedInstance(active.instanceName);
				setDumping(true);
				setOutput(`Dump je već u tijeku za instancu "${active.instanceName}"...\n\nLokacija: ${active.gcsPath}`);
				toast.info("Dump je u tijeku, nastavljam praćenje...");
				startPolling(active.instanceName);
			}
		}).catch(() => {});

		return () => {
			if (pollRef.current) clearInterval(pollRef.current);
		};
	}, []);

	const startPolling = (instanceName) => {
		if (pollRef.current) clearInterval(pollRef.current);

		pollRef.current = setInterval(async () => {
			try {
				const status = await rest("GET", `/api/dbDumpStatus/${instanceName}`);

				if (status.status === "done") {
					clearInterval(pollRef.current);
					setDumping(false);
					setOutput(`Dump završen.\n\nLokacija: ${status.gcsPath}\nVrijeme: ${status.finishedAt}`);
					toast.success("Dump je uspješno završen!");
				} else if (status.status === "error") {
					clearInterval(pollRef.current);
					setDumping(false);
					setOutput(`Dump je failao.\n\nGreška: ${status.error}`);
					toast.error("Dump je failao: " + status.error);
				}
			} catch (err) {
				clearInterval(pollRef.current);
				setDumping(false);
			}
		}, POLL_INTERVAL);
	};

	const handleDump = async () => {
		if (!selectedInstance) {
			alert("Odaberi instancu.");
			return;
		}

		const confirmed = window.confirm(
			`Sigurno želiš pokrenuti dump baze za instancu "${selectedInstance}"?`
		);
		if (!confirmed) return;

		try {
			startGlobalLoading();
			setOutput("");
			const result = await rest("POST", "/api/dbDump", { instanceName: selectedInstance });
			setDumping(true);
			setOutput(`Dump pokrenut...\n\nLokacija kada završi: ${result.gcsPath}`);
			toast.info("Dump je pokrenut. Polling svakih 5s...");
			startPolling(selectedInstance);
		} catch (err) {
			// 409 — dump već u tijeku
			toast.error(err.message);
		} finally {
			stopGlobalLoading();
		}
	};

	return (
		<div className="container">
			<div className="jumbotron jumbotron-fluid">
				<div>
					<h1 className="display-4">DB Dump</h1>
					<p className="lead">
						Pokrenuti dump odabrane instance i pohraniti na Google Cloud Storage.
					</p>
				</div>
			</div>

			<div className="w-50">
				<div className="form-group mt-2">
					<label>Instanca</label>
					<select
						className="form-control"
						value={selectedInstance}
						onChange={(e) => setSelectedInstance(e.target.value)}
						disabled={dumping}
					>
						<option value="">-- odaberi instancu --</option>
						{instances.map((inst) => (
							<option key={inst.uuid} value={inst.name}>
								{inst.name}
							</option>
						))}
					</select>
				</div>
			</div>

			<button
				onClick={handleDump}
				className="btn btn-primary mt-3 mb-3"
				disabled={dumping}
			>
				{dumping ? "DUMP U TIJEKU..." : "APPLY"}
			</button>
			&ensp;
			<button
				onClick={() => props.history.goBack()}
				className="btn btn-outline-primary mt-3 mb-3"
				disabled={dumping}
			>
				CANCEL
			</button>

			{output ? (
				<textarea
					readOnly={true}
					style={{ width: "100%", height: "15vh" }}
					value={output}
					className="mt-3"
				/>
			) : null}
		</div>
	);
};

export default DbDump;
